import React from "react";
import { Outlet, Navigate } from "react-router-dom";
// redux staet
import { useSelector } from "react-redux";

const ProtectedRoutes = () => {
  const userToken = useSelector((state) => state.userToken);
  return userToken ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
